import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'asetid', 'asdesc', 'catgid',  'tgl1', 'tgl2', 'DimCol', 'DimVal', 'nomorpo', 'tgldepr1', 'tgldepr2','uraian'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/facatgreclass${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(data) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.post('/facatgreclass', data);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/facatgreclass/${obj.tablekey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    posting(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(`/facatgreclass/posting`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    postingUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(`/facatgreclass/unposting`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }, 
    printjv(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            let str = '';
            try {
                str = '?key=' + encodeURIComponent(obj.tablekey);
                url = `/facatgreclass/printjv`;

                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'asetid', 'asdesc', 'catgid', 'category', 'tgldepr1', 'tgldepr2', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal', 'nomorpo'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/facatgreclass/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'fa_depreciation_list.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    category() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/fixedasset/category`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    currency() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/currency/cbo");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    })
}

};